import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import VdooMappingForm from './VdooMappingForm';
import VdooCredentialsForm from './VdooCredentialsForm';
import { columnRenderArrayData } from 'utils/tableUtils';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import { isEmpty } from 'lodash';

const VdooConfigListing = (props) => {
    const featureFlags = useFeatureFlag();

    const columns = useMemo(() =>[{
        title: "Artifact",
        dataIndex: "artifactName",
        width: 130,
        render: columnRenderArrayData,
    },
    {
        title: "Version",
        dataIndex: "version",
        width: 130,
        render: version => isEmpty(version) ? "All" : columnRenderArrayData(version),
    }
], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={VdooMappingForm}
            CredentialsForm={VdooCredentialsForm}
            extraColumns={columns}
        />
    );
}

export default VdooConfigListing;
